/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/HighlightedArticles/theme';

export const HighlightedArticlesTheme = theme;
